import {
  ClassificationIcon,
  NoData,
  RenderWhen,
  Time
} from "../../../../../components";
import { Schema } from "../../../../samples/@types/common";
import SearchLink from "../../../../search/components/links/SearchLink";
import { DomainReport } from "../../../@types";
import ThirdPartyReputationStats from "../../../components/common/ThirdPartyReputationStats";
import { UrlThreatIntelReason } from "../../../mappings";
import NetworkLink from "../../common/components/NetworkLink";

export const schema: Schema<DomainReport> = {
  fields: [
    {
      name: "status",
      displayTitle: <ClassificationIcon />,
      className: "text-center",
      style: { padding: "10px", width: "3%" },
      component: ({ classification, threat_level }) => (
        <ClassificationIcon
          size="big"
          classification={classification}
          riskScore={threat_level}
        />
      )
    },
    {
      name: "url",
      displayTitle: "Domain",
      style: { width: "35%" },
      component: ({ requested_domain: domain, classification }) => (
        <NetworkLink link={domain} classification={classification} />
      )
    },
    {
      name: "last_analyzed",
      displayTitle: "Last Analyzed",
      style: { width: "18%" },
      component: ({ last_seen }) => (
        <RenderWhen condition={Boolean(last_seen)} fallback={<NoData />}>
          <Time time={last_seen} className="time-exact" withTitle />
        </RenderWhen>
      )
    },
    {
      name: "reason",
      displayTitle: "Classification Reason",
      style: { width: "18%" },
      component: ({ reason }) => (
        <RenderWhen condition={Boolean(reason)} fallback={<NoData />}>
          <UrlThreatIntelReason reason={reason} />
        </RenderWhen>
      )
    },
    {
      name: "threat",
      displayTitle: "Threat",
      style: { width: "16%" },
      component: ({ threat_name: threatName }) => (
        <RenderWhen condition={Boolean(threatName)} fallback={<NoData />}>
          <SearchLink
            className="underline"
            keyword="THREATNAME"
            value={threatName ?? ""}
            data-testid="domain-related-domains-threat-link"
          >
            {threatName}
          </SearchLink>
        </RenderWhen>
      )
    },
    {
      name: "detections",
      displayTitle: "Detections",
      style: { width: "10%" },
      component: ({ third_party_reputations: { statistics } = {} }) => (
        <ThirdPartyReputationStats
          maliciousCount={statistics?.malicious}
          totalCount={statistics?.total}
        />
      )
    }
  ]
};
